import { PolicyGroupAndRolesOptional } from 'shared/utils/policy-controller';

import { routes as ogpRouteDefinitions } from 'ogp/Routes';
import { hqRoutes as hqRouteDefinitions } from 'hq/Routes';
import { RouteProps } from 'react-router-dom';
import React from 'react';
import {
  FeatureFlagKey,
  FeatureFlagMode,
} from 'shared/guards/feature-flag-guard/feature-flag-guard.types';

export type RouteDefinition = RouteProps & {
  path: string;
  fallbackPath?: string;
  layout?: React.ComponentType<{ children?: React.ReactNode }>;
  queryParams?: Record<string, string>;
  search?: string;
  requiredFeatureFlags?: FeatureFlagKey[];
  featureFlagMatch?: FeatureFlagMode;
  hqImpersonationOnly?: boolean;
} & PolicyGroupAndRolesOptional;

export const hqPrefix = '/hq';

export const routes = {
  ...ogpRouteDefinitions,
  ...hqRouteDefinitions,
};
